import { ref, computed, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import { useAuthStore } from '@/store/auth';
// import {  cleanAuthParams } from '@/utils/wechat'

export default {
  name: 'BindPhone',
  setup() {
    const route = useRoute();
    const authStore = useAuthStore();
    const phone = ref('');
    const phoneError = ref('');

    /**
     * 校验手机号格式
     * @returns {Boolean} 手机号是否有效
     */
    const isPhoneValid = computed(() => {
      return /^1[3-9]\d{9}$/.test(phone.value) && !phoneError.value;
    });

    /**
     * 实时校验手机号格式
     */
    const validatePhone = () => {
      if (!/^1[3-9]\d{9}$/.test(phone.value)) {
        phoneError.value = '请输入有效的11位手机号码';
      } else {
        phoneError.value = '';
      }
    };

    /**
     * 处理绑定操作
     */
    const handleBind = () => {
      // 从URL获取code参数
      // 调用store中的绑定方法
      authStore.bindPhoneNumber(phone.value);
    };
    onMounted(() => {});
    return {
      authStore,
      phone,
      phoneError,
      isPhoneValid,
      validatePhone,
      handleBind,
      route
    };
  }
};